import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect, useState } from "react";
import { Box, Chip, TextField } from "@mui/material";
import GeneralLoading from "../../../shared-components/Loading";
import { useApiClient } from "../../../api";

const MarkSchemeSearch = ({ onSelect, subject, educationLevel }) => {
  const [inputValue, setInputValue] = useState("");
  const [selectedMarkScheme, setSelectedMarkScheme] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const ApiClient = useApiClient();

  useEffect(() => {
    let active = true;
    setLoading(true);

    const fetchMarkSchemes = async () => {
      if (!active) return;
      try {
        const result = await ApiClient.question.searchMarkSchemes({
          name: inputValue,
          subject: subject.id,
          educationLevel: educationLevel.id,
        });
        setOptions(result || []);
      } catch (err) {
        console.error(err);
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchMarkSchemes();

    return () => {
      active = false;
    };
  }, [inputValue]);

  const handleChange = (event, value) => {
    if (!value) {
      return;
    }
    setSelectedMarkScheme(value); // set local state
    if (onSelect) {
      onSelect(value); // propagate up if needed
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "50%", gap: 2 }}>
      <Autocomplete
        sx={{ flexGrow: 1 }}
        value={selectedMarkScheme}
        onChange={handleChange}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        options={options}
        getOptionLabel={(option) => option.name || ""}
        loading={loading}
        renderOption={(props, option) => (
          <li {...props}>
            {option.name}
            {option.fruitifyApproved && (
              <Chip
                label="Fruitify"
                size="small"
                color="primary"
                sx={{ ml: 1 }}
              />
            )}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search for a mark scheme"
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <GeneralLoading
                      direction="row"
                      size={25}
                      message="Searching..."
                      sx={{ mr: 1 }}
                    />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default MarkSchemeSearch;
